import { gql } from '@apollo/client/core';

const BANNER_CONTENT_QUERY = gql`
  query ($contentType: String!, $fieldName: String!) {
    bannerContent(contentType: $contentType, fieldName: $fieldName)
  }
`;

export default BANNER_CONTENT_QUERY;
